import React from "react";
import { useTranslation } from "react-i18next";
import "./kioskHelpFooter.scss";

interface IKioskHelpFooterProps {
  message?: string;
}

export function KioskHelpFooter({ message }: IKioskHelpFooterProps) {
  const { t } = useTranslation();

  const defaultMessage = t("Need help? Please see the Pro shop staff for assistance.");

  return <p className="ui-kiosk-help">{message || defaultMessage}</p>;
}
